import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { AppState } from '../root-store/state';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LookupService } from '../shared/services/lookup.service';
import { ProviderWebsite } from '../shared/models/provider-website';
import { SystemConfig } from '../shared/models/system-config-model';
import { selectCurrentLanguage, selectCurrentWebsite, selectCurrentWebsiteDisplayName, selectCustomerPortalUrl, selectPartnerSitesForFooter, selectSystemConfigs } from 'src/app/root-store/selectors';
import { PartnerSitesModel } from '../shared/models/partner-sites-mode';
import { EnvService, SsrService } from '@hrra/core';

@Component({
    selector: 'app-layout-footer',
    // templateUrl: `./${theme.name}/layout-footer.component.html`,
    // styleUrls: [`./${theme.name}/layout-footer.component.scss`],
    templateUrl: './redesign/layout-footer.component.html',
    styleUrls: ['./redesign/layout-footer.component.scss'],
    standalone: false
})
export class LayoutFooterComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('topGe') topGe: ElementRef<HTMLElement>;

  // kept from ngAfterViewInit: by ngOnDestroy the footer DOM is already detached, so getElementById can't find it
  private topGeCounter: HTMLElement | null = null;

  date = Date.now();

  //TODO: Enum
  facebookLinkKey: string;
  linkedLinkKey: string;
  providerWebsiteId: number;


  partnerSitesForFooter$: Observable<PartnerSitesModel[]>;
  website$: Observable<ProviderWebsite>;
  language$: Observable<string>;
  systemConfigs$: Observable<SystemConfig>;
  websiteDisplayName$: Observable<string>;
  customerPortalUrl$: Observable<string>;
  currentLanguage$: Observable<string>;

  constructor(private store: Store<AppState>, private service: LookupService, private envService: EnvService,
    private ssr: SsrService, @Inject(DOCUMENT) private document: Document){
   }

  ngOnInit(): void {
    this.providerWebsiteId = this.envService.tenantId
    this.partnerSitesForFooter$ = this.store.pipe(select(selectPartnerSitesForFooter));
    this.website$ = this.store.pipe(select(selectCurrentWebsite));
    this.language$ = this.store.pipe(select(selectCurrentLanguage));
    this.systemConfigs$ = this.store.pipe(select(selectSystemConfigs));
    this.websiteDisplayName$ = this.store.pipe(select(selectCurrentWebsiteDisplayName));
    this.customerPortalUrl$ = this.store.pipe(select(selectCustomerPortalUrl));
    this.currentLanguage$ = this.store.pipe(select(selectCurrentLanguage));
  }

  // the top.ge counter lives outside Angular (index.html + counter-loader.js), so the footer borrows it and
  // hands it back to body on destroy; the next footer instance re-attaches it without reloading the script
  ngAfterViewInit(): void {

    if (!this.isTopGeOn()) {
      return;
    }

    this.topGeCounter = this.document.getElementById('top-ge-counter-container');

    this.topGeCounter!.hidden = false;
    this.topGe.nativeElement.appendChild(this.topGeCounter!);

  }

  ngOnDestroy(): void {

    if (!this.isTopGeOn()) {
      return;
    }

    this.topGeCounter!.hidden = true;
    this.document.body.appendChild(this.topGeCounter!);
  }

  // browser check too: on the server EnvService.topGeOn falls back to its "true" default
  private isTopGeOn(): boolean {
    return this.ssr.isPlatformBrowser() && this.envService.topGeOn == 'true';
  }
}
